// extracted by mini-css-extract-plugin
module.exports = {"container":"NumberCounter_container_gAPJm","increment":"NumberCounter_increment_3VJFY","decrement":"NumberCounter_decrement_YCr2s","number":"NumberCounter_number_22prv"};